
const verifySchema = () => {
  return {
    otp: {
      presence: {
        allowEmpty: false,
        message: '^لطفا کد تایید خود را وارد کنید.'
      },
      length: {
        is: 6,
        message: '^کد تایید وارد شده صحیح نیست.'
      }
    }
  }
}

export default verifySchema
